angular.module('picmonicng').controller('GermanDonkeyBridgeController', [
  '$scope',
  function ($scope) {
    $scope.formData = {};
    $scope.actionSetId = 2237;
    $scope.emailSubscribeSubmitted = false;
    $scope.$emit('endInteraction');
  },
]);
